import { DefaultButton } from "office-ui-fabric-react";
import * as React from "react";
import { getTheme } from "@uifabric/styling";

export default class ADSDefaultButton extends DefaultButton {
    render() {
        const { styles } = this.props;
        const theme = getTheme();

        const newStyles = {
            ...styles,
            root: [
                {
                    background: theme.palette.black,
                    color: theme.palette.white
                }
            ]
        };

        return (
            <DefaultButton
                {...this.props}
                styles={newStyles}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ADSDefaultButton/ADSDefaultButton.js